export default {
    ar: ['ipa', 'iea', 'iva'],
    en: ['*'],
    es: ['ipa', 'iea', 'iva', 'vea', 'iga'],
    de: ['ipa', 'iea', 'iva', 'iga'],
    fr: ['ipa', 'iea', 'iva', 'vea', 'iga'],
    it: ['ipa', 'iva'],
    pl: ['ipa', 'iea', 'iva'],
    pt: ['ipa', 'iea', 'iva', 'iga', 'vea', 'cia'],
};
